import { trackEvent } from './track-event'

type Props = {
  origin: 'list' | 'pdp'
  itemName: string
  itemId: string
  type: string
}

export function trackRemoveFromWishlist({ origin, itemName, itemId, type }: Props) {
  trackEvent({
    event: 'remove_from_wishlist',
    event_name: 'user_interaction',
    action: 'click - remove_from_wishlist',
    wishlist_location: origin,
    item: itemName,
    item_id: itemId,
    type,
  })
}
